export const COURSESLIST_FETCH_START = "COURSESLIST_FETCH_START";
export const COURSESLIST_FETCH_SUCCESS = "COURSESLIST_FETCH_SUCCESS";
export const COURSESLIST_FETCH_FAIL = "COURSESLIST_FETCH_FAIL";
